export default __webpack_public_path__ + "static/avater-bac02586b7a117485f2b0ec9523961a2.png";